module.exports = __webpack_public_path__ + "img/flickr.77875225.svg";